import React from 'react';

import { PillBadge } from '@lightspeed/flame/Badge';
import { CardSection } from '@lightspeed/flame/Card';
import { Box } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

import { StyledCard } from './MultiLocationSale.style';

type HoverabelCardProps = {
  selected?: boolean;
  onClick?: () => void;
  title: string;
  content: string;
  badge?: BadgeProps;
  showBadge: boolean;
  style?: React.CSSProperties;
  disableHover?: boolean;
  id?: string;
};

type BadgeProps = {
  variant: 'success' | 'primary' | 'default';
  text: string;
  style?: React.CSSProperties;
};

export default function HoverableCard({
  selected,
  title,
  content,
  badge,
  showBadge,
  style,
  onClick,
  disableHover = false,
  ...remainingProps
}: HoverabelCardProps) {
  return (
    <StyledCard
      {...remainingProps}
      large
      style={{ border: selected ? '2px solid #2E61DE' : '2px solid #FFFF', ...style }}
      onClick={onClick}
      disableHover={disableHover}
    >
      <CardSection style={{ padding: '24px', paddingBottom: '40px' }}>
        {showBadge ? (
          <Box height="24px" marginBottom="12px">
            {badge ? <HighlightBadge {...badge} /> : null}
          </Box>
        ) : null}
        <Text
          data-test="hover-card-title"
          fontSize="16px"
          fontWeight={700}
          lineHeight="24px"
          mb="4px"
        >
          {title}
        </Text>
        <Text data-test="hover-card-title" color="#5C626A">
          {content}
        </Text>
      </CardSection>
    </StyledCard>
  );
}

export function HighlightBadge({ text, variant, style }: BadgeProps) {
  let borderColor: string = '';
  let backgroundColor: string = '';

  switch (variant) {
    case 'default':
      borderColor = '#BCC4CA';
      backgroundColor = '#D7DCE1';
      break;

    case 'primary':
      borderColor = '#829FF5';
      backgroundColor = '#D6DFFD';
      break;

    case 'success':
      borderColor = '#88F398';
      backgroundColor = '#D8FCDC';
      break;

    default:
      break;
  }

  return (
    <>
      <PillBadge
        style={{ ...style, border: `1px solid ${borderColor}`, letterSpacing: 'normal' }}
        backgroundColor={backgroundColor}
        data-test="hover-card-pill-badge"
      >
        <Text textTransform="none" fontSize="14px">
          {text}
        </Text>
      </PillBadge>
    </>
  );
}
